// src/components/menuData.js

export const menuItems = [
  // COFFEE – HOT
  {
    id: 1,
    name: 'Single Espresso',
    description: 'Strong and bold single shot',
    price: 180,
    category: 'coffee-hot',
    image_url: '/images/espresso.jpg',
    tags: ['basic'],
  },
  {
    id: 2,
    name: 'Double Espresso',
    description: 'Strong and bold double shot',
    price: 240,
    category: 'coffee-hot',
    // image_url: '/images/double-espresso.jpg',
    tags: ['basic'],
  },
  {
    id: 3,
    name: 'Triple Espresso',
    description: 'Strong and bold triple shot',
    price: 300,
    category: 'coffee-hot',
    // image_url: '/images/triple-espresso.jpg'
  },
  {
    id: 4,
    name: 'Quadruple Espresso',
    description: 'Strong and bold quadruple shot',
    price: 390,
    category: 'coffee-hot',
    // image_url: '/images/quadruple-espresso.jpg'
  },
  {
    id: 5,
    name: 'Americano',
    description: 'Espresso with hot water',
    price: 240,
    category: 'coffee-hot',
    image_url: '/images/americano.jpg'
  },
  {
    id: 6,
    name: 'Americano Double shot',
    description: 'Espresso with hot water',
    price: 260,
    category: 'coffee-hot',
    // image_url: '/images/double-americano.jpg'
  },
  {
    id: 7,
    name: 'Americano Triple shot',
    description: 'Espresso with hot water',
    price: 320,
    category: 'coffee-hot',
    // image_url: '/images/triple-americano.jpg'
  },
  {
    id: 8,
    name: 'Americano Quadruple shot',
    description: 'Espresso with hot water',
    price: 400,
    category: 'coffee-hot',
    // image_url: '/images/quadruple-americano.jpg'
  },
  {
    id: 9,
    name: 'Cappuccino',
    description: 'Espresso with steamed milk and foam',
    price: 240,
    category: 'coffee-hot',
    image_url: '/images/cappuccino.jpg',
    tags: ['basic', 'popular'],
  },
  {
    id: 10,
    name: 'Cappuccino Double shot',
    description: 'Espresso with steamed milk and foam',
    price: 260,
    category: 'coffee-hot',
    // image_url: '/images/double-cappuccino.jpg'
  },
  {
    id: 11,
    name: 'Cappuccino Triple shot',
    description: 'Espresso with steamed milk and foam',
    price: 320,
    category: 'coffee-hot',
    // image_url: '/images/triple-cappuccino.jpg'
  },
  {
    id: 12,
    name: 'Cappuccino Quadruple shot',
    description: 'Espresso with steamed milk and foam',
    price: 400,
    category: 'coffee-hot',
    // image_url: '/images/quadruple-cappuccino.jpg'
  },
  {
    id: 13,
    name: 'Latte',
    description: 'Smooth espresso with milk',
    price: 490,
    category: 'coffee-hot',
    image_url: '/images/latte.jpg'
  },
  {
    id: 14,
    name: 'Flat White',
    description: 'Espresso coffee and steamed milk',
    price: 250,
    category: 'coffee-hot',
    // image_url: '/images/flat-white.jpg'
  },
  {
    id: 15,
    name: 'Espresso Macchiatto',
    description: 'Espresso with steamed, foamed whole milk',
    price: 190,
    category: 'coffee-hot',
    // image_url: '/images/macchiatto.jpg'
  },
  {
    id: 16,
    name: 'Espresso Macchiatto Double shot',
    description: 'Espresso with steamed, foamed whole milk',
    price: 250,
    category: 'coffee-hot',
    // image_url: '/images/double-macchiatto.jpg'
  },
  {
    id: 17,
    name: 'Greek Coffee',
    description: 'Coffee made with a fine grind of coffee',
    price: 210,
    category: 'coffee-hot',
    image_url: '/images/greek-coffee.jpg',
    tags: ['basic']
  },
  {
    id: 18,
    name: 'Double Greek Coffee',
    description: 'Coffee made with a fine grind of coffee',
    price: 230,
    category: 'coffee-hot',
    // image_url: '/images/double-greek-coffee.jpg'
  },
  {
    id: 19,
    name: 'French Coffee',
    description: 'French coffee',
    price: 260,
    category: 'coffee-hot',
    // image_url: '/images/french-coffee.jpg'
  },

  // COFFEE – ICE
  {
    id: 20,
    name: 'Frappe',
    description: 'Chilled greek frappe',
    price: 220,
    category: 'coffee-ice',
    image_url: '/images/frappe.jpg',
    tags: ['popular'],
  },
  {
    id: 21,
    name: 'Nescafe',
    description: 'Nescafe coffee',
    price: 220,
    category: 'coffee-ice',
    // image_url: '/images/nescafe.jpg'
  },
  {
    id: 22,
    name: 'Iced Latte',
    description: 'Chilled espresso with milk and ice',
    price: 270,
    category: 'coffee-ice',
    // image_url: '/images/iced-latte.jpg'
  },
  {
    id: 23,
    name: 'Freddo Espresso Single shot',
    description: 'Greek-style iced espresso',
    price: 200,
    category: 'coffee-ice',
    // image_url: '/images/single-freddo-espresso.jpg'
  },
  {
    id: 24,
    name: 'Freddo Espresso Double shot',
    description: 'Greek-style iced espresso',
    price: 250,
    category: 'coffee-ice',
    // image_url: '/images/double-freddo-espresso.jpg',
    tags: ['basic', 'popular'],
  },
  {
    id: 25,
    name: 'Freddo Espresso Triple shot',
    description: 'Greek-style iced espresso',
    price: 350,
    category: 'coffee-ice',
    // image_url: '/images/triple-freddo-espresso.jpg',
  },
  {
    id: 26,
    name: 'Freddo Espresso Quadruple shot',
    description: 'Greek-style iced espresso',
    price: 390,
    category: 'coffee-ice',
    // image_url: '/images/quadruple-freddo-espresso.jpg'
  },
  {
    id: 27,
    name: 'Freddo Cappuccino',
    description: 'Iced espresso with cold foam',
    price: 260,
    category: 'coffee-ice',
    // image_url: '/images/freddo-cappuccino.jpg',
    tags: ['basic', 'popular']
  },
  {
    id: 28,
    name: 'Freddo Cappuccino Triple shot',
    description: 'Iced espresso with cold foam',
    price: 320,
    category: 'coffee-ice',
    // image_url: '/images/freddo-cappuccino.jpg'
  },
  {
    id: 29,
    name: 'Freddo Cappuccino Quadruple shot',
    description: 'Iced espresso with cold foam',
    price: 400,
    category: 'coffee-ice',
    // image_url: '/images/freddo-cappuccino.jpg'
  },
  {
    id: 30,
    name: 'Freddo Cappuccino Single shot',
    description: 'Iced espresso with cold foam',
    price: 220,
    category: 'coffee-ice',
    // image_url: '/images/freddo-cappuccino.jpg'
  },

  // FOOD – SANDWICH
  {
    id: 31,
    name: 'Tuna Sandwich',
    description: 'Tuna sandwich',
    price: 300,
    category: 'food-sandwich',
    // image_url: '/images/tuna-sandwich.jpg',
    tags: ['popular'],
  },
  {
    id: 32,
    name: 'Salami Sandwich',
    description: 'Salami sandwich',
    price: 300,
    category: 'food-sandwich',
    // image_url: '/images/salami-sandwich.jpg'
  },
  {
    id: 33,
    name: 'Chicken Sandwich',
    description: 'Chicken sandwich',
    price: 350,
    category: 'food-sandwich',
    // image_url: '/images/chicken-sandwich.jpg',
    tags: ['popular'],
  },
  {
    id: 34,
    name: 'Ham Sandwich',
    description: 'Ham sandwich',
    price: 300,
    category: 'food-sandwich',
    // image_url: '/images/ham-sandwich.jpg'
  },
  {
    id: 35,
    name: 'Turkey Sandwich',
    description: 'Turkey sandwich',
    price: 300,
    category: 'food-sandwich',
    // image_url: '/images/turkey-sandwich.jpg'
  },

  // FOOD – TOAST
  {
    id: 36,
    name: 'Cheese Toast',
    description: 'Toasted bread with melted cheese',
    price: 220,
    category: 'food-toast',
    // image_url: '/images/cheese-toast.jpg',
    tags: ['basic', 'popular'],
  },
  {
    id: 37,
    name: 'Turkey Cheese Toast',
    description: 'Turkey and cheese toast',
    price: 220,
    category: 'food-toast',
    // image_url: '/images/turkey-toast.jpg'
  },
  {
    id: 38,
    name: 'Ham Cheese Toast',
    description: 'Ham and cheese toast',
    price: 220,
    category: 'food-toast',
    // image_url: '/images/turkey-toast.jpg',
    tags: ['popular'],
  },

  // FOOD – PASTRY
  {
    id: 39,
    name: 'Τυρόπιτα τριγώνου',
    description: 'Classic triangular cheese pie',
    price: 250,
    category: 'food-pastry',
    image_url: '/images/tiropita-trigonh.jpg',
    tags: ['basic', 'popular'],
  },
  {
    id: 40,
    name: 'Σπανακόπιτα',
    description: 'Traditional spinach pie',
    price: 260,
    category: 'food-pastry',
    image_url: '/images/spanakopita-feta-xoriatikh.jpg',
    tags: ['popular'],
  },
  {
    id: 41,
    name: 'Σπανακοτυρόπιτα',
    description: 'Spinach and cheese pie',
    price: 260,
    category: 'food-pastry',
    image_url: '/images/spanakopita-nistisimi-xoriatikh.jpg'
  },
  {
    id: 42,
    name: 'Κοτόπιτα',
    description: 'Chicken pie',
    price: 300,
    category: 'food-pastry',
    image_url: '/images/spring-rolls-kotopoulo.jpg'
  },
  {
    id: 43,
    name: 'Τυρόπιτα Χωριάτικη',
    description: 'Rustic village-style cheese pie',
    price: 260,
    category: 'food-pastry',
    // image_url: '/images/spanakopita-feta-xoriatikh.jpg'
  },
  {
    id: 44,
    name: 'Πίτσα σπέσιαλ',
    description: 'Special pizza slice',
    price: 350,
    category: 'food-pastry',
    // image_url: '/images/pizza-special.jpg',
    tags: ['featured'],
  },
  {
    id: 45,
    name: 'Κρουασάν 4 τυριά-μπέικον',
    description: 'Croissant with 4 cheeses and bacon',
    price: 350,
    category: 'food-pastry',
    image_url: '/images/krouasan-tessera-tiria-bacon.jpg',
    tags: ['featured']
  },
  {
    id: 46,
    name: 'Κουλούρι με φέτα',
    description: 'Sesame koulouri stuffed with feta',
    price: 250,
    category: 'food-pastry',
    image_url: '/images/koulouri-feta.jpg'
  },
  {
    id: 47,
    name: 'Τυρόπιτα κουρού',
    description: 'Kourou-style cheese pie (shortcrust)',
    price: 200,
    category: 'food-pastry',
    image_url: '/images/tiropita-kourou.jpg'
  },
  {
    id: 48,
    name: 'Πείνιρλι μπέικον',
    description: 'Peynirli with bacon',
    price: 350,
    category: 'food-pastry',
    // image_url: '/images/peinirli-bacon.jpg',
    tags: ['featured']
  },
  {
    id: 49,
    name: 'Πείνιρλι κοτόπουλο',
    description: 'Peynirli with chicken',
    price: 350,
    category: 'food-pastry',
    image_url: '/images/mprios-kotopoulo.jpg'   // corrected filename
  },
  {
    id: 50,
    name: 'Μεσογειακό με φέτα',
    description: 'Mediterranean pie with feta',
    price: 250,
    category: 'food-pastry',
    image_url: '/images/kourou-mesogeiako-feta.jpg'
  },
  {
    id: 51,
    name: 'Κρουασίνια Βουτύρου',
    description: 'Small butter croissant',
    price: 60,
    category: 'food-pastry',
    image_url: '/images/mini-krouasan-voutirou.jpg'
  },
  {
    id: 52,
    name: 'Κρουασίνια Σοκολάτας',
    description: 'Small chocolate croissant',
    price: 80,
    category: 'food-pastry',
    image_url: '/images/krouasini-sokolatas.jpg'
  },
  {
    id: 53,
    name: 'Κριτσίνια τυριού',
    description: 'Breadcrumbs with cheese',
    price: 120,
    category: 'food-pastry',
    image_url: '/images/milopita.jpg'
  },
  {
    id: 54,
    name: 'Κρουασίνια Κοτόπουλου',
    description: 'Small croissant with chicken',
    price: 180,
    category: 'food-pastry',
    // image_url: '/images/milopita.jpg'
  },
  {
    id: 55,
    name: 'Κρουασάν Βουτύρου',
    description: 'Butter Croissant',
    price: 180,
    category: 'food-pastry',
    image_url: '/images/krouasan-voutirou.jpg'
  },
  {
    id: 56,
    name: 'Κρουασάν Σοκολάτας',
    description: 'Chocolate Croissant',
    price: 200,
    category: 'food-pastry',
    image_url: '/images/krouasan-sokolatas.jpg'
  },
  {
    id: 57,
    name: 'Μηλόπιτα',
    description: 'Apple pie',
    price: 250,
    category: 'food-pastry',
    image_url: '/images/milopita.jpg',
    tags: ['featured']
  },
  {
    id: 58,
    name: 'Μπουγάτσα',
    description: 'Classic custard bougatsa',
    price: 250,
    category: 'food-pastry',
    image_url: '/images/mpougatsa.jpg',
    tags: ['featured']
  },
  {
    id: 59,
    name: 'Κουλούρι Θεσσαλονίκης',
    description: 'Classic Thessaloniki sesame koulouri',
    price: 120,
    category: 'food-pastry',
    image_url: '/images/koulouri-thessalonikh.jpg',
    tags: ['basic', 'popular'],
  },
  {
    id: 60,
    name: 'Κουλούρι με κασέρι',
    description: 'Koulouri stuffed with kaseri cheese',
    price: 180,
    category: 'food-pastry',
    image_url: '/images/koulouri-kaseri.jpg'
  },
  {
    id: 61,
    name: 'Ζαμπονοτυροπιτόπιτα',
    description: 'Ham and cheese pie (sfoliata style)',
    price: 250,
    category: 'food-pastry',
    image_url: '/images/zamponotiropita-saltsa.jpg'
  },
  {
    id: 62,
    name: 'Κασεροπιτόπιτα',
    description: 'Kaseri cheese pie',
    price: 250,
    category: 'food-pastry',
    image_url: '/images/kaseropita.jpg'
  },
  {
    id: 63,
    name: 'Φλογυέρα Φιλαδέλφεια',
    description: 'Feta cheese flute pastry (Philadelphia style)',
    price: 250,
    category: 'food-pastry',
    image_url: '/images/flogera-filadelfia-galopoula.jpg'
  },
  {
    id: 64,
    name: 'Φλογυέρα Φιλαδ. Πολύσπορη',
    description: 'Multi-seed feta flute pastry',
    price: 280,
    category: 'food-pastry',
    // image_url: '/images/flogera-filadelfia-galopoula.jpg'
  },
  {
    id: 65,
    name: 'Λουκανικόπιτα με σάλτσα',
    description: 'Sausage pie with sauce',
    price: 250,
    category: 'food-pastry',
    image_url: '/images/loukanikopita-saltsa.jpg'
  },
  {
    id: 66,
    name: 'Μπριός με λουκάνικο',
    description: 'Brioche with sausage',
    price: 250,
    category: 'food-pastry',
    image_url: '/images/diplo-loukaniko-saltsa-tirion.jpg'
  },
  {
    id: 67,
    name: 'Μπριός κοτόπουλο',
    description: 'Chicken brioche sandwich',
    price: 350,
    category: 'food-pastry',
    image_url: '/images/mprios-kotopoulo.jpg'
  },
  {
    id: 68,
    name: 'Μπιφτεκοπιτόπιτα',
    description: 'Beef patty pie / biftekopita',
    price: 350,
    category: 'food-pastry',
    image_url: '/images/mpiftekopita.jpg'
  },

  // FOOD - SWEETS
  {
    id: 69,
    name: 'Donut Bueno',
    description: 'Donut Bueno',
    price: 250,
    category: 'food-sweets',
    // image_url: '/images/donut-bueno.jpg',
    tags: ['featured']
  },
  {
    id: 70,
    name: 'Donut Chocolate',
    description: 'Donut Chocolate',
    price: 250,
    category: 'food-sweets',
    // image_url: '/images/donut-chocolate.jpg'
  },
  {
    id: 71,
    name: 'Fried dough',
    description: 'Greek sweet fried dough with sugar',
    price: 200,
    category: 'food-sweets',
    // image_url: '/images/lokma.jpg'
  },
  {
    id: 72,
    name: 'Cake Chocolate-Vanilla',
    description: 'Delicious cake with chocolate and vanilla',
    price: 250,
    category: 'food-sweets',
    // image_url: '/images/cake.jpg',
    tags: ['featured']
  },
  {
    id: 73,
    name: 'Caramel Muffin',
    description: 'Caramel Muffin',
    price: 300,
    category: 'food-sweets',
    // image_url: '/images/caramel-muffin.jpg',
    tags: ['featured']
  },
  {
    id: 74,
    name: 'Redvelvet Muffin',
    description: 'Redvelvet Muffin',
    price: 300,
    category: 'food-sweets',
    // image_url: '/images/redvelvet-muffin.jpg'
  },
  {
    id: 75,
    name: 'Oreo Muffin',
    description: 'Oreo Muffin',
    price: 300,
    category: 'food-sweets',
    // image_url: '/images/oreo-muffin.jpg'
  },
  {
    id: 76,
    name: 'Chocolate-Vanilla Muffin',
    description: 'Chocolate-Vanilla Muffin',
    price: 250,
    category: 'food-sweets',
    // image_url: '/images/chocolate-canilla-muffin.jpg'
  },

  // DRINKS – JUICE
  {
    id: 77,
    name: 'Fresh Orange Juice',
    description: 'Fresh orange juice',
    price: 250,
    category: 'drinks-juice',
    image_url: '/images/orange-juice.jpg',
    tags: ['featured', 'popular']
  },
  {
    id: 78,
    name: 'Fresh Mix Fruit Juice',
    description: 'Fresh juice, mixed with multiple fruits',
    price: 350,
    category: 'drinks-juice',
    // image_url: '/images/mix-juice.jpg',
    tags: ['featured']
  },
  {
    id: 79,
    name: 'Juice Life',
    description: 'Life juice',
    price: 200,
    category: 'drinks-juice',
    // image_url: '/images/life-juice.jpg'
  },
  {
    id: 80,
    name: 'Smoothie',
    description: 'Delicious smoothies',
    price: 450,
    category: 'drinks-juice',
    image_url: '/images/smoothies.jpg',     // you listed smoothies.jpg
    tags: ['featured']
  },

  // DRINKS – SOFT
  {
    id: 81,
    name: 'Coca-Cola',
    description: 'Chilled soft drink 330ml',
    price: 150,
    category: 'drinks-soft',
    image_url: '/images/coke.jpg',
    tags: ['popular']
  },
  {
    id: 82,
    name: 'Coca-Cola Zero',
    description: 'Chilled soft drink 330ml',
    price: 150,
    category: 'drinks-soft',
    // image_url: '/images/coke-zero.jpg'
  },
  {
    id: 83,
    name: 'Coca-Cola Light',
    description: 'Chilled soft drink 330ml',
    price: 150,
    category: 'drinks-soft',
    // image_url: '/images/coke-light.jpg'
  },
  {
    id: 84,
    name: 'Coca-Cola Stevia',
    description: 'Chilled soft drink 330ml',
    price: 180,
    category: 'drinks-soft',
    // image_url: '/images/coke-stevia.jpg'
  },
  {
    id: 85,
    name: 'Sprite',
    description: 'Lemon-lime soda',
    price: 150,
    category: 'drinks-soft',
    // image_url: '/images/sprite.jpg'
  },
  {
    id: 86,
    name: 'Orangeade',
    description: 'Chillied soft orange soda',
    price: 150,
    category: 'drinks-soft',
    // image_url: '/images/orangeade.jpg'
  },
  {
    id: 87,
    name: 'Blue Orangeade',
    description: 'Chilled soft blue orange soda',
    price: 150,
    category: 'drinks-soft',
    // image_url: '/images/blue-orangeade.jpg'
  },
  {
    id: 88,
    name: 'Lemon Soda',
    description: 'Chilled lemon soda',
    price: 150,
    category: 'drinks-soft',
    // image_url: '/images/lemon-soda.jpg'
  },
  {
    id: 89,
    name: 'Lemon Soda Life',
    description: 'Chilled lemon soda Life',
    price: 300,
    category: 'drinks-soft',
    // image_url: '/images/lemon-soda-life.jpg'
  },
  {
    id: 90,
    name: 'Soda',
    description: 'Chilled soda',
    price: 180,
    category: 'drinks-soft',
    // image_url: '/images/soda.jpg'
  },

  // DRINKS – ENERGY
  {
    id: 91,
    name: 'Red Bull',
    description: 'Energy drink',
    price: 200,
    category: 'drinks-energy',
    image_url: '/images/redbull.jpg',
    tags: ['popular']
  },

  // DRINKS – WATER
  {
    id: 92,
    name: 'Mineral Water',
    description: '500ml bottled water',
    price: 50,
    category: 'drinks-water',
    // image_url: '/images/water.jpg'
  },
  {
    id: 93,
    name: 'Mineral Water Large',
    description: '1,5Lt bottled water',
    price: 100,
    category: 'drinks-water',
    // image_url: '/images/water.jpg'
  },

  // DRINKS – TEA
  {
    id: 94,
    name: 'Black Tea',
    description: 'Classic black tea',
    price: 190,
    category: 'drinks-tea',
    // image_url: '/images/black-tea.jpg'
  },
  {
    id: 95,
    name: 'Green Tea',
    description: 'Light green tea',
    price: 190,
    category: 'drinks-tea',
    // image_url: '/images/green-tea.jpg'
  },

  // DRINKS - CHOCOLATE
  {
    id: 96,
    name: 'Hot Chocolate',
    description: 'Classic hot chocolate',
    price: 280,
    category: 'chocolate-hot',
    // image_url: '/images/hot-chocolate.jpg',
    tags: ['popular']
  },
  {
    id: 97,
    name: 'Hot White Chocolate',
    description: 'Classic hot white chocolate',
    price: 330,
    category: 'chocolate-hot',
    // image_url: '/images/hot-white-chocolate.jpg'
  },
  {
    id: 98,
    name: 'Iced Chocolate',
    description: 'Classic iced chocolate',
    price: 280,
    category: 'chocolate-iced',
    // image_url: '/images/iced-chocolate.jpg',
    tags: ['popular']
  },
  {
    id: 99,
    name: 'Iced White Chocolate',
    description: 'Classic iced white chocolate',
    price: 330,
    category: 'chocolate-iced',
    // image_url: '/images/iced-white-chocolate.jpg'
  },
  {
    id: 100,
    name: 'Milko',
    description: 'Chocolate milk',
    price: 150,
    category: 'chocolate',
    // image_url: '/images/milko.jpg'
  },

  // DRINKS - LIQUEUR
  {
    id: 101,
    name: "Bailey's",
    description: 'Liqueur, mixes cream, whiskey, and cocoa',
    price: 70,
    category: 'drinks-liqueur',
    // image_url: '/images/bailey.jpg'
  },

  // DRINKS - BEER
  {
    id: 102,
    name: 'Beer 330ml',
    description: 'Cold beer 330ml',
    price: 150,
    category: 'drinks-beer',
    // image_url: '/images/beer.jpg'
  },
  {
    id: 103,
    name: 'Bottled Beer 330ml',
    description: 'Cold bottled beer 330ml',
    price: 200,
    category: 'drinks-beer',
    // image_url: '/images/bottled-beer.jpg'
  },
  {
    id: 104,
    name: 'Bottled Beer 500ml',
    description: 'Cold bottled beer 500ml',
    price: 300,
    category: 'drinks-beer',
    // image_url: '/images/bottled-beer500ml.jpg'
  },

  // DRINKS – ICED TEA
  {
    id: 105,
    name: 'Iced Tea',
    description: 'Cold flavored tea',
    price: 150,
    category: 'drinks-iced-tea',
    image_url: '/images/ice-tea.jpg'
  },

  // SWEETS
  {
    id: 116,
    name: 'Cheesecake',
    description: 'Creamy cheesecake slice',
    price: 480,
    category: 'sweets',
    // image_url: '/images/cheesecake.jpg'
  },
  {
    id: 117,
    name: 'Brownie',
    description: 'Chocolate brownie',
    price: 420,
    category: 'sweets',
    // image_url: '/images/brownie.jpg'
  },

  // ENERGY BOOST
  {
    id: 118,
    name: 'Bar Superfoods',
    description: 'High-protein energy bar',
    price: 220,
    category: 'energy-boost',
    // image_url: '../dataImages/imagesprotein-bar.jpg',
    tags: ['featured']
  },
  {
    id: 119,
    name: 'Protein Bowl',
    description: 'Homemade protein bowl',
    price: 400,
    category: 'energy-boost',
    // image_url: '/images/protein-bowl.jpg',
    tags: ['featured']
  },
  {
    id: 120,
    name: 'Bar Gourmet',
    description: 'Gourmet energy bar',
    price: 270,
    category: 'energy-boost',
    // image_url: '/images/gourmet-bar.jpg'
  }
];